import React, { useContext, useState } from 'react'
import { firestore } from '../../../../firebase'
import StateContext from '../../../../StateContext'

function TeamCoachesListTemplate({ coach, teamId, mode }) {
    const { userId, loggedIn } = useContext(StateContext)
    const [error, setError] = useState('')

    async function removeCoachHandler(e) {
        e.preventDefault()
        try {
            const teamCoachRef = firestore
                .collection('teams')
                .doc(teamId)
                .collection('coaches')
                .doc(coach.id)
            teamCoachRef.delete()
            console.log('deleted')
        } catch (error) {
            setError('Kunne ikke slette')
        }
    }

    return (
        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
            <div className="card">
                <img
                    src={coach.coach_image}
                    alt={coach.coach_name}
                    className="player-image image-fluid"
                />
                <div className="card-body">
                    <p>
                        <strong>{coach.coach_name}</strong>
                    </p>
                    <small className="text-muted">{coach.coach_role} </small>
                    {loggedIn &&
                        userId === 'aqX59RalZnV1sHLpS6UA1b5b4992' &&
                        mode === 'edit' && (
                            <div>
                                {error && (
                                    <div
                                        className="alert alert-danger"
                                        onClick={() => setError('')}
                                    >
                                        {error}
                                    </div>
                                )}
                                <button
                                    className="btn btn-sm btn-danger"
                                    onClick={removeCoachHandler}
                                >
                                    Slett
                                </button>
                            </div>
                        )}
                </div>
            </div>
        </div>
    )
}
export default TeamCoachesListTemplate
